export default {
  PAYMENT_METHODS: 'paymentMethods',

  PAYMENTS: 'payments',

  CURRENT_USER: 'currentUser',

  ORG_BALANCE: 'orgBalance',

  MEMBERSHIPS: 'memberships',

  USERS_SPEND: 'users_spend',

  ORGANIZATIONS: 'organizations',
};
